import {
  SAVE_TERMS_ACCEPTANCE_LOADING,
  SAVE_TERMS_ACCEPTANCE_SUCCESS,
  SAVE_TERMS_ACCEPTANCE_FAILED,
} from "../types";

interface TermsAcceptanceState {
  loading: boolean;
  data: any | null;
  error: any | null;
}

const initialState: TermsAcceptanceState = {
  loading: false,
  data: null,
  error: null,
};

export default function termsAcceptanceReducer(
  state = initialState,
  action: { type: string; payload?: any; error?: any; loading?: boolean }
): TermsAcceptanceState {
  switch (action.type) {
    case SAVE_TERMS_ACCEPTANCE_LOADING:
      return {
        ...state,
        loading: action.loading || false,
        error: null,
      };

    case SAVE_TERMS_ACCEPTANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };

    case SAVE_TERMS_ACCEPTANCE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
}
